import { create } from "zustand"

import { tabletStorage } from "@/lib/tablet/tablet-storage"

interface TabletState {
  token: string | null
  deviceId: string | null
  organizationId: string | null
  isPaired: boolean

  setPairing: (token: string, deviceId: string, organizationId: string) => void
  clearPairing: () => void
}

/**
 * Store Zustand pour l'état d'appairage de la tablette.
 * La source de vérité est le localStorage (via tabletStorage) pour survivre
 * aux reboots. Ce store est un cache en mémoire qui synchronise les
 * mutations pour que React re-render correctement.
 */
export const useTabletStore = create<TabletState>((set) => ({
  token: tabletStorage.getToken(),
  deviceId: tabletStorage.getDeviceId(),
  organizationId: tabletStorage.getOrganizationId(),
  isPaired: tabletStorage.isPaired(),

  setPairing: (token, deviceId, organizationId) => {
    tabletStorage.setPairing(token, deviceId, organizationId)
    set({ token, deviceId, organizationId, isPaired: true })
  },

  clearPairing: () => {
    tabletStorage.clear()
    set({ token: null, deviceId: null, organizationId: null, isPaired: false })
  },
}))
